module.exports = __webpack_public_path__ + "img/email-notifications.7e53f17e.svg";